// @flow
// import flattenDeep from 'lodash/flattenDeep';
import {
  takeEvery,
  put,
  call,
  select,
} from 'redux-saga/effects';
import { types as jwtTypes } from 'nozzmo-redux-jwt';
import { reset } from 'redux-form';
import { push } from 'react-router-redux';
import { purgeStoredState } from 'redux-persist';
import { normalize } from 'normalizr';
import { School } from '../api';
import persistorConfiguration from '../store/persistorConfiguration';
import * as selectors from '../reducers';
import {
  fetchSchoolSucceed,
  selectSchool,
  fetchSchoolFailed,
} from '../actions/schools';
import { school } from '../api/schemas/schools';
import { fibonacciBackoff } from '../lib/retry';


function* redirectAfterLogin(action) {
  // Clear form
  const token = yield select(selectors.getToken);

  // Get school from admin profile1
  const profile = yield select(selectors.getProfileOfType, 'admin');

  const mock = {
    delay: 1000,
    response: {
      statusCode: 200,
      body: {
        id: 1,
        name: 'El Valle',
        address: 'Zona 9',
        phone: '12341234',
      },
    },
  };

  let schoolResponse;
  try {
    schoolResponse = yield call(
      fibonacciBackoff,
      [School, 'detail'],
      { token, id: profile.school, mock },
    );

    // Redirect
    yield put(reset('loginForm'));
    yield put(push('/admin/backend/events'));
  } catch (e) {
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = e;

    // Fetch error
    yield put(fetchSchoolFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }

  const {
    entities: {
      schools,
    },
  } = normalize(schoolResponse, school);
  const schoolObj = schools[profile.school];

  yield put(
    fetchSchoolSucceed(
      schoolObj.id,
      schoolObj.name,
      schoolObj.address,
      schoolObj.phone,
    ),
  );
  yield put(selectSchool(profile.school));
}

function* cleanAfterLogout() {
  purgeStoredState(persistorConfiguration);
  yield put(push('/'));
}

export function* watchRedirectAfterLogin(): Iterator<any> {
  yield takeEvery(jwtTypes.LOGIN_SUCCEED, redirectAfterLogin);
}

export function* watchLogout(): Iterator<any> {
  yield takeEvery(jwtTypes.LOGOUT, cleanAfterLogout);
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/login.js